/* unplugin-vue-components disabled */import { render } from "./VersioningVideoDownloadButton.vue?vue&type=template&id=160c020e&ts=true"
import script from "./VersioningVideoDownloadButton.vue?vue&type=script&lang=ts"
export * from "./VersioningVideoDownloadButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__